"use client";

/**
 * Radial gauge showing developer activity score (0-100).
 */
import { c as _c } from "react/compiler-runtime";
interface DevScoreRadialProps {
  score: number;
  size?: number;
  label?: string;
}
function getScoreColor(score: number): string {
  if (score >= 70) return "#22c55e";
  if (score >= 40) return "#3b82f6";
  if (score >= 20) return "#eab308";
  return "#6b7280";
}
function getScoreLabel(score: number): string {
  if (score >= 70) return "Very Active";
  if (score >= 40) return "Active";
  if (score >= 20) return "Moderate";
  return "Low";
}
export function DevScoreRadial(t0) {
  const $ = _c(46);
  const {
    score,
    size: t1,
    label
  } = t0;
  const size = t1 === undefined ? 120 : t1;
  const isSmall = size <= 64;
  const strokeW = isSmall ? 5 : 8;
  const radius = (size - strokeW * 2) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = score / 100 * circumference;
  let t2;
  if ($[0] !== score) {
    t2 = getScoreColor(score);
    $[0] = score;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const color = t2;
  const scoreFontSize = isSmall ? size * 0.3 : size * 0.22;
  const labelFontSize = isSmall ? 0 : size * 0.085;
  let t3;
  if ($[2] !== size) {
    t3 = {
      width: size,
      height: size
    };
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `0 0 ${size} ${size}`;
  const t5 = size / 2;
  const t6 = size / 2;
  let t7;
  if ($[4] !== radius || $[5] !== strokeW || $[6] !== t5 || $[7] !== t6) {
    t7 = <circle cx={t5} cy={t6} r={radius} fill="none" stroke="hsl(230, 15%, 15%)" strokeWidth={strokeW} />;
    $[4] = radius;
    $[5] = strokeW;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = size / 2;
  const t9 = size / 2;
  const t10 = circumference - progress;
  let t11;
  if ($[9] !== circumference || $[10] !== color || $[11] !== radius || $[12] !== strokeW || $[13] !== t10 || $[14] !== t8 || $[15] !== t9) {
    t11 = <circle cx={t8} cy={t9} r={radius} fill="none" stroke={color} strokeWidth={strokeW} strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={t10} className="transition-all duration-1000 ease-out" />;
    $[9] = circumference;
    $[10] = color;
    $[11] = radius;
    $[12] = strokeW;
    $[13] = t10;
    $[14] = t8;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== size || $[18] !== t11 || $[19] !== t4 || $[20] !== t7) {
    t12 = <svg width={size} height={size} viewBox={t4} className="transform -rotate-90">{t7}{t11}</svg>;
    $[17] = size;
    $[18] = t11;
    $[19] = t4;
    $[20] = t7;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== color || $[23] !== scoreFontSize) {
    t13 = {
      color,
      fontSize: scoreFontSize
    };
    $[22] = color;
    $[23] = scoreFontSize;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== score) {
    t14 = score.toFixed(0);
    $[25] = score;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t13 || $[28] !== t14) {
    t15 = <span className="font-bold leading-none" style={t13}>{t14}</span>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== isSmall || $[31] !== labelFontSize || $[32] !== score) {
    t16 = !isSmall && <span className="text-gray-500 uppercase tracking-wider leading-tight mt-0.5" style={{
      fontSize: labelFontSize
    }}>{getScoreLabel(score)}</span>;
    $[30] = isSmall;
    $[31] = labelFontSize;
    $[32] = score;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t15 || $[35] !== t16) {
    t17 = <div className="absolute inset-0 flex flex-col items-center justify-center">{t15}{t16}</div>;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t12 || $[38] !== t17 || $[39] !== t3) {
    t18 = <div className="relative" style={t3}>{t12}{t17}</div>;
    $[37] = t12;
    $[38] = t17;
    $[39] = t3;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== label) {
    t19 = label && <span className="mt-2 text-xs text-gray-400 font-medium">{label}</span>;
    $[41] = label;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t18 || $[44] !== t19) {
    t20 = <div className="flex flex-col items-center">{t18}{t19}</div>;
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
}